(() => {
class StudioMeasure extends HTMLElement {
  get refs() { return Object.fromEntries([...this.querySelectorAll('[ref]')].map(el=>[el.getAttribute('ref'),el])); }
  connectedCallback() {}
  disconnectedCallback() {}
}
const ThemeEvents={variantUpdate:'sim:variant-update'};
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, event=>{
    document.dispatchEvent(new CustomEvent(ThemeEvents.variantUpdate,{detail:{data:{html:event.data.html}}}));
  });
}
function syncNameRequirements(scope = document) {
  scope.querySelectorAll('[data-sim-name-input]').forEach(field => {
    const variantId = field.form?.elements.namedItem('id')?.value || '';
    const required = field.dataset.nameMode === 'always' ||
      (field.dataset.nameMode === 'variant' && field.dataset.nameVariants.split(',').includes(variantId));
    field.required = required;
    field.setAttribute('aria-required', String(required));
    field.setCustomValidity(required && !field.value.trim() ? field.dataset.nameMessage : '');
    const star = field.closest('[data-sim-options]')?.querySelector('[data-sim-name-star]');
    if (star) star.hidden = !required;
  });
}
syncNameRequirements();
document.addEventListener('input', event => {
  if (event.target.matches('[data-sim-name-input]')) syncNameRequirements(event.target.closest('[data-sim-options]'));
});
document.addEventListener('change', event => {
  const info = event.target.closest('product-info');
  if (info) requestAnimationFrame(() => syncNameRequirements(info));
});
document.addEventListener(ThemeEvents.variantUpdate, () => syncNameRequirements());
document.addEventListener('submit',event=>{
 const form=event.target;
 if (!(form instanceof HTMLFormElement) || !form.closest('product-info')?.querySelector('[data-sim-options]')) return;
 syncNameRequirements(form.closest('product-info'));
 if (!form.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); form.reportValidity(); }
},true);

class BannerMeasure extends StudioMeasure {
  connectedCallback() {
    super.connectedCallback();

    this.unitPriceCents = Number(this.dataset.unitPriceCents || 0);
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}} TL';

    this.addEventListener('input', this.onInput);
    this.addEventListener('change', this.onInput);
    document.addEventListener(
      ThemeEvents.variantUpdate,
      this.onVariantUpdate
    );

    this.recalculate();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('input', this.onInput);
    this.removeEventListener('change', this.onInput);
    document.removeEventListener(
      ThemeEvents.variantUpdate,
      this.onVariantUpdate
    );
  }

  onInput = () => {
    this.recalculate();
  };

  onVariantUpdate = (event) => {
    const html = event?.detail?.data?.html;

    if (
      !(html instanceof Document) &&
      !(html instanceof DocumentFragment)
    ) {
      return;
    }

    const next = html.querySelector(
      'banner-measure-component[data-unit-price-cents]'
    );

    if (!next) return;

    const cents = Number(next.dataset.unitPriceCents || 0);
    if (!Number.isFinite(cents)) return;

    this.unitPriceCents = cents;
    this.dataset.unitPriceCents = String(cents);

    this.recalculate();
  };

  recalculate() {
    const first = this.positiveNumber(
      this.refs.widthInput?.value
    );

    const second = this.positiveNumber(
      this.refs.heightInput?.value
    );

    const shortSide = Math.min(first, second);
    const longSide = Math.max(first, second);
    const hasBoth = first > 0 && second > 0;

    const valid =
      hasBoth &&
      shortSide >= 50 &&
      shortSide <= 150 &&
      longSide >= 70 &&
      longSide <= 1000;

    const exactM2 = hasBoth
      ? (first * second) / 10000
      : 0;

    
    const billableM2 = valid
      ? Math.max(1, Math.ceil(exactM2))
      : 0;

    const totalCents =
      billableM2 * this.unitPriceCents;

    if (this.refs.areaDisplay) {
      this.refs.areaDisplay.textContent =
        exactM2 > 0
          ? this.numberText(exactM2)
          : '0';
    }

    if (this.refs.billableDisplay) {
      this.refs.billableDisplay.textContent =
        billableM2 > 0
          ? (window.simProductLabels?.billable || '{{ area }} m² üzerinden fiyatlandırılır').replace('{{ area }}', billableM2)
          : '—';
    }

    if (this.refs.unitPriceDisplay) {
      this.refs.unitPriceDisplay.textContent =
        this.formatMoney(this.unitPriceCents);
    }

    if (this.refs.totalPriceDisplay) {
      this.refs.totalPriceDisplay.textContent =
        this.formatMoney(totalCents);
    }

    if (this.refs.measureError) {
      this.refs.measureError.hidden =
        !hasBoth || valid;
    }

    this.setProperty(
      this.refs.widthProp,
      valid ? `${first} cm` : ''
    );

    this.setProperty(
      this.refs.heightProp,
      valid ? `${second} cm` : ''
    );

    this.setProperty(
      this.refs.areaProp,
      valid
        ? `${this.numberText(exactM2)} m²`
        : ''
    );

    this.setProperty(
      this.refs.billableProp,
      valid
        ? `${billableM2} m²`
        : ''
    );

    this.setQuantity(
      billableM2 > 0 ? billableM2 : 1
    );

    this.updatePersonalization();

    this.setAddEnabled(
      valid && this.personalizationValid()
    );
  }

  updatePersonalization() {
    const mode =
      this.refs.designMode?.value || '';

    const needsFile = mode === 'file';

    if (this.refs.fileField) {
      this.refs.fileField.hidden = !needsFile;
    }

    if (this.refs.fileInput) {
      this.refs.fileInput.required = needsFile;
      this.refs.fileInput.disabled = !needsFile;
    }

    
    const form = this.getForm();

    form
      ?.closest('product-info')
      ?.classList.toggle(
        'product-form--banner-file-selected',
        needsFile
      );
  }

  personalizationValid() {
    const mode =
      this.refs.designMode?.value || '';

    if (!mode) return false;

    if (
      mode === 'file' &&
      !this.refs.fileInput?.files?.length
    ) {
      return false;
    }

    return Boolean(
      this.refs.phoneInput?.value.trim()
    );
  }

  getForm() {
    const formId =
      this.dataset.productFormId;

    const form = formId
      ? document.getElementById(formId)
      : null;

    return form instanceof HTMLFormElement
      ? form
      : null;
  }

  setQuantity(quantity) {
    const form = this.getForm();

    const root =
      form?.closest('product-info') ||
      this.closest('product-info') ||
      document;

    const inputs = root.querySelectorAll(
      'input[name="quantity"]'
    );

    for (const input of inputs) {
      if (!(input instanceof HTMLInputElement)) {
        continue;
      }

      input.value = String(quantity);

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  setAddEnabled(enabled) {
    const form = this.getForm();
    if (!form) return;

    const buttons = form.querySelectorAll(
      'button[type="submit"][name="add"]'
    );

    for (const button of buttons) {
      if (!(button instanceof HTMLButtonElement)) {
        continue;
      }

      button.disabled = !enabled;
    }
  }

  setProperty(input, value) {
    if (!input) return;

    input.value = value;
    input.disabled = value === '';
  }

  positiveNumber(value) {
    const number = Number(
      String(value ?? '').replace(',', '.')
    );

    return Number.isFinite(number) &&
      number > 0
      ? number
      : 0;
  }

  numberText(number) {
    return number
      .toFixed(2)
      .replace('.', ',');
  }

  formatMoney(cents) {
    const amount = (
      Math.max(0, cents) / 100
    )
      .toFixed(2)
      .replace('.', ',');

    if (
      this.moneyFormat.includes('{{amount}}')
    ) {
      return this.moneyFormat.replace(
        '{{amount}}',
        amount
      );
    }

    return `${amount} TL`;
  }
}

if (
  !customElements.get(
    'banner-measure-component'
  )
) {
  customElements.define(
    'banner-measure-component',
    BannerMeasure
  );
}


class WallpaperMeasure extends StudioMeasure {
  connectedCallback() {
    super.connectedCallback();
    this.#unitPriceCents = Number(this.dataset.unitPriceCents || 0);
    this.#moneyFormat = this.dataset.moneyFormat || '{{amount}} TL';
    this.#currency = this.dataset.currency || 'TRY';

    this.addEventListener('input', this.#onInput);
    this.addEventListener('change', this.#onInput);
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);

    this.#syncQuantityUi(false);
    this.#recalculate();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('input', this.#onInput);
    this.removeEventListener('change', this.#onInput);
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #unitPriceCents = 0;
  #moneyFormat = '';
  #currency = 'TRY';

  #onInput = () => {
    this.#recalculate();
  };

  
  #onVariantUpdate = (event) => {
    const html = event?.detail?.data?.html;
    if (!(html instanceof Document || html instanceof DocumentFragment)) return;

    const next = html.querySelector('wallpaper-measure-component[data-unit-price-cents]');
    if (!next) return;

    const cents = Number(next.getAttribute('data-unit-price-cents') || 0);
    if (!Number.isFinite(cents)) return;

    this.#unitPriceCents = cents;
    this.dataset.unitPriceCents = String(cents);
    this.#recalculate();
  };

  #recalculate() {
    const width = this.#positiveNumber(this.refs.widthInput?.value);
    const height = this.#positiveNumber(this.refs.heightInput?.value);
    const pieces = Math.max(1, Math.floor(this.#positiveNumber(this.refs.qtyInput?.value) || 1));

    if (this.refs.qtyInput && String(pieces) !== this.refs.qtyInput.value) {
      this.refs.qtyInput.value = String(pieces);
    }

    const exactM2 = width > 0 && height > 0 ? (width / 100) * (height / 100) * pieces : 0;
    const billableM2 = exactM2 > 0 ? Math.max(1, Math.ceil(exactM2)) : 0;
    const totalCents = billableM2 * this.#unitPriceCents;

    if (this.refs.areaDisplay) {
      this.refs.areaDisplay.textContent = exactM2 > 0 ? exactM2.toFixed(2).replace('.', ',') : '0';
    }

    if (this.refs.billableDisplay) {
      this.refs.billableDisplay.hidden = !(exactM2 > 0 && billableM2 !== Number(exactM2.toFixed(2)));
      if (!this.refs.billableDisplay.hidden) {
        this.refs.billableDisplay.textContent = (window.simProductLabels?.cartArea || 'Sepete {{ area }} m² olarak eklenir').replace('{{ area }}', billableM2);
      }
    }

    if (this.refs.unitPriceDisplay) {
      this.refs.unitPriceDisplay.textContent = this.#formatMoney(this.#unitPriceCents);
    }

    if (this.refs.totalPriceDisplay) {
      this.refs.totalPriceDisplay.textContent = this.#formatMoney(totalCents);
    }

    this.#setProp(this.refs.widthProp, width > 0 ? `${width} cm` : '');
    this.#setProp(this.refs.heightProp, height > 0 ? `${height} cm` : '');
    this.#setProp(this.refs.qtyProp, pieces > 0 ? String(pieces) : '');
    this.#setProp(
      this.refs.areaProp,
      exactM2 > 0 ? `${exactM2.toFixed(2).replace('.', ',')} m² (sepet: ${billableM2} m²)` : ''
    );

    this.#setQuantity(billableM2 > 0 ? billableM2 : 1);
    this.#setAddEnabled(width > 0 && height > 0);
  }

  
  #positiveNumber(value) {
    const n = Number(String(value ?? '').replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  
  #setProp(input, value) {
    if (!input) return;
    input.value = value;
    input.disabled = value === '';
  }

  
  #setQuantity(qty) {
    const formId = this.dataset.productFormId;
    const root = formId ? document.getElementById(formId)?.closest('product-info') : null;
    const scope = root || this.closest('product-info') || document;

    const inputs = scope.querySelectorAll('input[name="quantity"], quantity-selector-component input[name="quantity"]');
    for (const input of inputs) {
      if (!(input instanceof HTMLInputElement)) continue;
      input.value = String(qty);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  
  #setAddEnabled(enabled) {
    const formId = this.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    if (!(form instanceof HTMLFormElement)) return;

    const buttons = form.querySelectorAll('button[type="submit"][name="add"]');
    for (const button of buttons) {
      if (!(button instanceof HTMLButtonElement)) continue;
      if (enabled) {
        if (button.getAttribute('data-wallpaper-measure-disabled') === 'true') {
          button.disabled = false;
          button.removeAttribute('data-wallpaper-measure-disabled');
        }
      } else {
        button.setAttribute('data-wallpaper-measure-disabled', 'true');
        button.disabled = true;
      }
    }
  }

  
  #syncQuantityUi(hide = true) {
    const formId = this.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    if (!(form instanceof HTMLFormElement)) return;

    form.closest('product-info')?.classList.toggle('product-form--wallpaper-measure', hide !== false);
  }

  
  #formatMoney(cents) {
    const amount = (Math.max(0, cents) / 100).toFixed(2);
    const withComma = amount.replace('.', ',');
    if (this.#moneyFormat.includes('{{amount}}')) {
      return this.#moneyFormat.replace('{{amount}}', withComma).replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
    }
    return `${withComma} TL`;
  }
}

if (!customElements.get('wallpaper-measure-component')) {
  customElements.define('wallpaper-measure-component', WallpaperMeasure);
}



class StickerMeasure extends StudioMeasure {
  connectedCallback() {
    super.connectedCallback();

    this.#unitPriceCents = Number(
      this.dataset.unitPriceCents || 0
    );

    this.#moneyFormat =
      this.dataset.moneyFormat || '{{amount}} TL';

    this.addEventListener('input', this.#onInput);
    this.addEventListener('change', this.#onInput);

    document.addEventListener(
      ThemeEvents.variantUpdate,
      this.#onVariantUpdate
    );

    this.#syncQuantityUi(true);
    this.#updatePersonalizationFields();
    this.#recalculate();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('input', this.#onInput);
    this.removeEventListener('change', this.#onInput);

    document.removeEventListener(
      ThemeEvents.variantUpdate,
      this.#onVariantUpdate
    );
  }

  #unitPriceCents = 0;
  #moneyFormat = '';

  #onInput = () => {
    this.#updatePersonalizationFields();
    this.#recalculate();
  };

  #onVariantUpdate = (event) => {
    const html = event?.detail?.data?.html;

    if (
      !(html instanceof Document) &&
      !(html instanceof DocumentFragment)
    ) {
      return;
    }

    const next = html.querySelector(
      'sticker-measure-component[data-unit-price-cents]'
    );

    if (!next) return;

    const cents = Number(
      next.getAttribute('data-unit-price-cents') || 0
    );

    if (!Number.isFinite(cents)) return;

    this.#unitPriceCents = cents;
    this.dataset.unitPriceCents = String(cents);

    this.#recalculate();
  };

  #recalculate() {
    const width = this.#positiveNumber(
      this.refs.widthInput?.value
    );

    const height = this.#positiveNumber(
      this.refs.heightInput?.value
    );

    const pieces = Math.max(
      1,
      Math.floor(
        this.#positiveNumber(this.refs.qtyInput?.value) || 1
      )
    );

    const sheetWidth =
      this.#positiveNumber(this.dataset.sheetWidth) || 30;

    const sheetHeight =
      this.#positiveNumber(this.dataset.sheetHeight) || 45;

    const gap = Math.max(
      0,
      Number(this.dataset.cutGap || 0.4)
    );

    if (
      this.refs.qtyInput &&
      String(pieces) !== this.refs.qtyInput.value
    ) {
      this.refs.qtyInput.value = String(pieces);
    }

    let capacity = 0;
    let placement = '';

    if (width > 0 && height > 0) {
      const normal =
        Math.floor(sheetWidth / (width + gap)) *
        Math.floor(sheetHeight / (height + gap));

      const rotated =
        Math.floor(sheetWidth / (height + gap)) *
        Math.floor(sheetHeight / (width + gap));

      capacity = Math.max(normal, rotated);

      placement =
        rotated > normal
          ? (window.simProductLabels?.rotated || 'Döndürülmüş')
          : (window.simProductLabels?.normal || 'Normal');
    }

    const sheets =
      capacity > 0
        ? Math.ceil(pieces / capacity)
        : 0;

    const totalCents =
      sheets * this.#unitPriceCents;

    const validSize =
      width > 0 &&
      height > 0 &&
      capacity > 0;

    if (this.refs.capacityDisplay) {
      this.refs.capacityDisplay.textContent =
        capacity > 0
          ? `${capacity} ${window.simProductLabels?.pieces || 'adet'}`
          : '—';
    }

    if (this.refs.sheetDisplay) {
      this.refs.sheetDisplay.textContent =
        sheets > 0
          ? `${sheets} ${window.simProductLabels?.sheets || 'yaprak'}`
          : '—';
    }

    if (this.refs.unitPriceDisplay) {
      this.refs.unitPriceDisplay.textContent =
        this.#formatMoney(this.#unitPriceCents);
    }

    if (this.refs.totalPriceDisplay) {
      this.refs.totalPriceDisplay.textContent =
        validSize ? this.#formatMoney(totalCents) : this.dataset.emptyPriceLabel;
    }

    if (this.refs.orderSummary) {
      this.refs.orderSummary.textContent = validSize
        ? this.dataset.orderSummaryLabel.replace('[count]', pieces)
        : '';
      this.refs.orderSummary.hidden = !validSize;
    }

    if (this.refs.sizeError) {
      this.refs.sizeError.hidden = !(
        width > 0 &&
        height > 0 &&
        capacity === 0
      );
    }

    this.#setProp(
      this.refs.widthProp,
      width > 0 ? `${width} cm` : ''
    );

    this.#setProp(
      this.refs.heightProp,
      height > 0 ? `${height} cm` : ''
    );

    this.#setProp(
      this.refs.requestedQtyProp,
      pieces > 0 ? String(pieces) : ''
    );

    this.#setProp(
      this.refs.capacityProp,
      capacity > 0 ? `${capacity} ${window.simProductLabels?.pieces || 'adet'}` : ''
    );

    this.#setProp(
      this.refs.sheetProp,
      sheets > 0 ? String(sheets) : ''
    );

    this.#setProp(
      this.refs.placementProp,
      placement
    );

    this.#setQuantity(
      sheets > 0 ? sheets : 1
    );

    this.#setAddEnabled(
      validSize &&
      this.#personalizationIsValid()
    );
  }

  #updatePersonalizationFields() {
    const type =
      this.refs.personalizationType?.value || '';

    const needsImage =
      type === 'image_text';

    const hasType =
      type !== '';
const formId = this.dataset.productFormId;

const form = formId
  ? document.getElementById(formId)
  : null;

form
  ?.closest('product-info')
  ?.classList.toggle(
    'product-form--sticker-image-selected',
    needsImage
  );
    if (this.refs.imageField) {
      this.refs.imageField.hidden = !needsImage;
    }

    if (this.refs.imageInput) {
      this.refs.imageInput.required = needsImage;
      this.refs.imageInput.disabled = !needsImage;
    }

    if (this.refs.textInput) {
      this.refs.textInput.required = hasType;
      this.refs.textInput.disabled = !hasType;
    }
  }

  #personalizationIsValid() {
    const type =
      this.refs.personalizationType?.value || '';

    const text =
      this.refs.textInput?.value?.trim() || '';

    if (!type || !text) {
      return false;
    }

    if (type === 'image_text') {
      return Boolean(
        this.refs.imageInput?.files?.length
      );
    }

    return true;
  }

  #positiveNumber(value) {
    const number = Number(
      String(value ?? '').replace(',', '.')
    );

    return (
      Number.isFinite(number) &&
      number > 0
    )
      ? number
      : 0;
  }

  #setProp(input, value) {
    if (!input) return;

    input.value = value;
    input.disabled = value === '';
  }

  #setQuantity(quantity) {
    const formId =
      this.dataset.productFormId;

    const root = formId
      ? document
          .getElementById(formId)
          ?.closest('product-info')
      : null;

    const scope =
      root ||
      this.closest('product-info') ||
      document;

    const inputs = scope.querySelectorAll(
      'input[name="quantity"], ' +
      'quantity-selector-component input[name="quantity"]'
    );

    for (const input of inputs) {
      if (!(input instanceof HTMLInputElement)) {
        continue;
      }

      input.value = String(quantity);

      input.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  }

  #setAddEnabled(enabled) {
    const formId =
      this.dataset.productFormId;

    const form = formId
      ? document.getElementById(formId)
      : null;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const buttons = form.querySelectorAll(
      'button[type="submit"][name="add"]'
    );

    for (const button of buttons) {
      if (!(button instanceof HTMLButtonElement)) {
        continue;
      }

      if (enabled) {
        if (
          button.getAttribute(
            'data-sticker-measure-disabled'
          ) === 'true'
        ) {
          button.disabled = false;

          button.removeAttribute(
            'data-sticker-measure-disabled'
          );
        }
      } else {
        button.setAttribute(
          'data-sticker-measure-disabled',
          'true'
        );

        button.disabled = true;
      }
    }
  }

  #syncQuantityUi(hide = true) {
    const formId =
      this.dataset.productFormId;

    const form = formId
      ? document.getElementById(formId)
      : null;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    form
      .closest('product-info')
      ?.classList.toggle(
        'product-form--sticker-measure',
        hide
      );
  }

  #formatMoney(cents) {
    const amount =
      (Math.max(0, cents) / 100).toFixed(2);

    const withComma =
      amount.replace('.', ',');

    if (
      this.#moneyFormat.includes('{{amount}}')
    ) {
      return this.#moneyFormat
        .replace('{{amount}}', withComma)
        .replace(
          '{{amount_no_decimals}}',
          String(Math.round(cents / 100))
        );
    }

    return `${withComma} TL`;
  }
}

if (
  !customElements.get(
    'sticker-measure-component'
  )
) {
  customElements.define(
    'sticker-measure-component',
    StickerMeasure
  );
}
})();
